import actionTypes from '../actionTypes';
import { buildMessage } from '../helper/call.helper';
import messageAction from './message.action';
import callAction from './call.action';
import globalAction from './global.action';
import { globalStateSelector } from '../selector';

export default {
  setCallInfo: ( data, userId ) => dispatch => {
    dispatch({
      type: actionTypes.CALL_INFO,
      payload: data,
      userId : userId
    });
  },
  setCallList: data => dispatch => {
    dispatch({
      type: actionTypes.CALL_List,
      payload: data
    });
  },
  process: (type, data) => (dispatch, getState) => {
    console.log(`[Call-Action] Started `, type, data);

    if (type === 'AddTAGToCall') {
      let call = {
        pattern: 'AddTAGToCall',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callHangup') {
      let call = {
        pattern: 'hangUp',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callMute') {
      let call = {
        pattern: 'callMute',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callUnMute') {
      let call = {
        pattern: 'callUnMute',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callTransferStart') {
      let call = {
        pattern: 'callTransferStart',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callTransferCancel') {
      let call = {
        pattern: 'callTransferCancel',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callTransferAgent') {
      let call = {
        pattern: 'callTransferAgent',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callTransferTalk') {
      let call = {
        pattern: 'callTransferTalk',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callTransferAgentMerge') {
      let call = {
        pattern: 'callTransferAgentMerge',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callTransferAgentCancel') {
      let call = {
        pattern: 'callTransferAgentCancel',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callHold') {
      let call = {
        pattern: 'callHold',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callUnHold') {
      let call = {
        pattern: 'callUnHold',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'dtmfSend') {
      let call = {
        pattern: 'dtmfSend',
        type: 'callHandler',
        body: {
          ...data
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'monitorCall') {
      
      console.log("monitorCall data ", data);
      let call = {
        pattern: 'monitorCall',
        type: 'callHandler',
        body: data,
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      console.log("monitorCall call ", call);
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else if (type === 'callInitiate') {
      const state = getState();
      let selectedTeam = globalStateSelector.getSelectedTeam(state);
      let info = data.info || {}; 
      let callingMode = info.callingMode || ""; 
      if( data.teamId ) {
        selectedTeam = {
          _id: data.teamId,
          name: data.teamName
        }
      }
      let call = {
        pattern: 'callAndConnect',
        type: 'callHandler',
        body: {
          team: selectedTeam,
          call: {
            type: 'phone',
            number: data.phoneNumber
          },
          ...info,
        },
        replayTo: 'call-service'
      };
      call = buildMessage(call);
      if( callingMode != "preview" ){
        dispatch(callAction.setCallCustomerNumber({ data: data.phoneNumber }));
        dispatch(callAction.setCallCustomerName({ data: 'No Name' }));
      }
      // dispatch(callAction.setCallStartTime(""));
      // dispatch(callAction.setCallCurrentTime(""));
      // dispatch(messageAction.emitSocketMessage('message-processor', call));
      if( selectedTeam && selectedTeam._id ) {
        dispatch(messageAction.configProcessor(`tagList`, {"teamId":selectedTeam._id}));
      }

      if( selectedTeam && selectedTeam._id ) {
        dispatch(globalAction.dynamicUpdate({ data  : {"key":"comments",value : []} }));
        dispatch(messageAction.configProcessor(`customerComments`, {"teamId": selectedTeam._id, "mobileNumber" : data.phoneNumber, "limit": 10 ,"page_no": 1 }));
        dispatch(globalAction.dynamicUpdate({ data  : {"key":"callTeam", value : {"id":selectedTeam._id} } })); 
        if( callingMode != "preview" ){
          dispatch(globalAction.dynamicUpdate({ data  : {"key":"custInfo",value : {} } }));
          dispatch(messageAction.configProcessor(`contactList`, {"teamId": selectedTeam._id, "mobileNumber" : data.phoneNumber }));
        }
      }
      dispatch(messageAction.emitSocketMessage('message-processor', call));
    } else {
      console.error(`[Call-Action] Type Not Define `, type);
    }
  },
  setCallCustomerNumber: data => dispatch => {
    dispatch({
      type: actionTypes.CALL_CUSTOMER_NUMBER,
      payload: data
    });
  },
  setCallCustomerName: data => dispatch => {
    dispatch({
      type: actionTypes.CALL_CUSTOMER_NAME,
      payload: data
    });
  },
  setCallStartTime: data => dispatch => {
    dispatch({
      type: actionTypes.CALL_START_TIME,
      payload: data
    });
  },
  setCallCurrentTime: data => dispatch => {
    dispatch({
      type: actionTypes.CALL_CURRENT_TIME,
      payload: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/store/action/call.action.js